import {Box, Grid} from "@mui/material"
import {checkVisibility} from "../../../misc/precondition-evaluation"
import Content from "../../../components/Content"
import React from "react"
import {muiGridPrototypes} from "./mui-grid-prototypes"
import {containerQuery, containerQueryDown} from "../../../assets/container-query"
import PropTypes from "prop-types"

const gridContainerProps = ["direction", "justifyContent", "alignItems", "wrap", "flexGrow"]

export const containerManagedFlexContainerPrototype = [
    ...gridContainerProps.map(prop => muiGridPrototypes[prop]),
    {
        key: "compactBreakpoint",
        type: "INTEGER",
        label: "Compact Breakpoint (px) — drunter Layout-/Display-Switch",
        size: 6,
    },
    {
        key: "compactDirection",
        type: "SELECT",
        label: "Compact Direction (Flex)",
        size: 6,
        options: [
            {value: "row", label: "row"},
            {value: "row-reverse", label: "row-reverse"},
            {value: "column", label: "column"},
            {value: "column-reverse", label: "column-reverse"},
        ],
    },
]

const gridPropToSxKey = {
    direction: "flexDirection",
    justifyContent: "justifyContent",
    alignItems: "alignItems",
    wrap: "flexWrap",
    flexGrow: "flexGrow",
}

const collectExplicitFlexSx = (containerProps) => Object.fromEntries(
    gridContainerProps
        .map(propName => [gridPropToSxKey[propName], containerProps[propName]])
        .filter(([, value]) => value !== undefined && value !== null && value !== ""),
)

const buildChildHideStyles = (compactBreakpoint, child) => {
    if (!compactBreakpoint) return null
    if (child?.displayWide) return containerQueryDown(compactBreakpoint, {display: "none"})
    if (child?.displayCompact) return containerQuery(compactBreakpoint, {display: "none"})
    return null
}

export const ContainerManagedFlexContainer = ({container, disabled, getDataFromPointer}) => {
    const compactBreakpoint = Number(container?.compactBreakpoint) || null
    const gridProps = {
        spacing: container?.containerSpacing ? `${container.containerSpacing}px` : "0px",
    }
    const gridSx = {
        ...collectExplicitFlexSx(container),
        ...(container.minWidth ? {minWidth: container.minWidth} : {}),
        ...(container.minHeight ? {minHeight: container.minHeight} : {}),
        ...(compactBreakpoint
            ? containerQueryDown(compactBreakpoint, {
                flexDirection: container.compactDirection ?? "column",
            })
            : {}),
    }

    const grid = (
        <Grid container {...gridProps} sx={gridSx}>
            {container.children.map((widget) => {
                if (!checkVisibility(widget, getDataFromPointer)) return null
                const hide = buildChildHideStyles(compactBreakpoint, widget)
                const content = (
                    <Content
                        key={widget.id}
                        child={widget}
                        disabled={disabled}
                    />
                )
                if (!hide) return content
                return (
                    <Box
                        key={widget.id}
                        sx={{display: "contents", ...hide}}>
                        {content}
                    </Box>
                )
            })}
        </Grid>
    )

    return compactBreakpoint
        ? <Box sx={{containerType: "inline-size", width: "100%", height: "100%"}}>{grid}</Box>
        : grid
}

ContainerManagedFlexContainer.propTypes = {
    container: PropTypes.shape({
        direction: PropTypes.string,
        justifyContent: PropTypes.string,
        alignItems: PropTypes.string,
        wrap: PropTypes.string,
        containerSpacing: PropTypes.string,
        compactBreakpoint: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        compactDirection: PropTypes.string,
    }),
    disabled: PropTypes.bool,
}
